import { createSlice, CaseReducer, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { get, post } from 'api/requests';

import { IParamsReq } from 'types';
import {
  StartSettlementStore,
  PostData,
  PostStartSettlemenResp,
  GetStartSettlementResp,
} from 'pages/StartSettlement/types';

const initialState: StartSettlementStore = {
  count: 0,
  currentRequestId: undefined,
  data: [],
  loading: false,
  noData: false,
};

const reset: CaseReducer<StartSettlementStore> = () => initialState;

export const startSettlementSlice = createSlice({
  name: 'startSettlement',
  initialState,
  reducers: {
    reset,
  },
  extraReducers: builder => {
    builder
      .addCase(getStartSettlement.pending, (state, action) => {
        state.loading = true;
        state.currentRequestId = action.meta.requestId;
      })
      .addCase(getStartSettlement.fulfilled, (state, { payload }) => {
        state.loading = false;

        if (payload) {
          const { results, count } = payload;
          state.data = results;
          state.count = count;
          state.noData = results.length === 0;
        }
      })
      .addCase(getStartSettlement.rejected, (state, action) => {
        const { requestId } = action.meta;

        if (state.loading === true && state.currentRequestId === requestId) {
          state.loading = false;
        }
      });
  },
});

export const { reset: setReset } = startSettlementSlice.actions;

export const getStartSettlement = createAsyncThunk(
  'settlement/getSettlement',
  async (params: IParamsReq, thinkApi) => {
    try {
      const { data } = await get<GetStartSettlementResp>('/api/settlement/dss/', params);
      return data;
    } catch (error) {
      return thinkApi.rejectWithValue(error);
    }
  },
);

export const postStartSettlement = createAsyncThunk(
  'settlement/postSettlement',
  async (formData: PostData, thinkApi) => {
    try {
      const { data } = await post<PostData, AxiosResponse<PostStartSettlemenResp>>(
        '/api/settlement/dss/',
        formData,
      );
      return data;
    } catch (error) {
      return thinkApi.rejectWithValue(error);
    }
  },
);
